// extracted by mini-css-extract-plugin
export default {"iconAvatar":"DiscoverChannelsPage_iconAvatar__71jI5"};